import React, { useEffect } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import { Button } from "@mui/material";
import Footer from "./Footer";
import Select from "react-dropdown-select";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import apiService from "../core/service/detail";
import { postMethod } from "../core/service/common.api";
import { setAuthorization } from "../core/service/axios";

function Home() {
  const initialFormValue = {
    tfa: "",
  };
  const [formValue, setFormValue] = useState(initialFormValue);
  const [tfaValidate, settfaValidate] = useState(false);
  const [validationnErr, setvalidationnErr] = useState("");
  const [buttonLoader, setbuttonLoader] = useState(false);
  const navigate = useNavigate();

  const { tfa } = formValue;
  const { state } = useLocation();

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (value.length < 7) {
      let formData = { ...formValue, ...{ [name]: value } };
      setFormValue(formData);
      validate(formData);
    }
  };

  const formSubmit = async () => {
    validate(formValue);
    if (formValue.tfa !== "") {
      var data = {
        apiUrl: apiService.tfaVerify,
        payload: {
          userToken: tfa,
          socketToken: state?.socketToken,
        },
      };
      setbuttonLoader(true);
      var resp = await postMethod(data);
      setbuttonLoader(false);

      setFormValue(initialFormValue);

      if (resp.status == true) {
        console.log(resp, "respiknknknkmn");
        toast.success(resp.Message);
        await setAuthorization(resp.token);
        localStorage.setItem("user_token", resp.token);
        localStorage.setItem("tfa_status", resp.tfa);
        localStorage.setItem("socket_token", resp.socketToken);

        if (resp.type == "User") {
          navigate("/userdashboard");
          localStorage.setItem("UserType", resp.Type);
        } else {
          navigate("/dashboard");
          localStorage.setItem("UserType", resp.Type);
        }
      } else {
        toast.error(resp.Message);
      }
    }
  };

  const validate = async (values) => {
    const errors = {};
    if (!values.tfa) {
      errors.tfa = "2FA is Required";
      settfaValidate(true);
    }
    setvalidationnErr(errors);
    return errors;
  };

  return (
    <div className="header ">
      <Header />
      <main>
        <div className="login_form">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="card_login w-100 shadow">
                  <h3>Enter 2FA code to login</h3>
                  <div>
                    <div class="form_login_input">
                      <label>Your 2FA</label>
                      <input
                        type="Number"
                        class="form-control"
                        placeholder="Enter 2FA Code"
                        name="tfa"
                        value={tfa}
                        onKeyDown={(evt) =>
                          ["e", "E", "+", "-"].includes(
                            evt.key
                          ) && evt.preventDefault()
                        }
                        onChange={handleChange}
                      />
                      {tfaValidate == true ? (
                        <p className="text-danger"> {validationnErr.tfa} </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div class="form_login_input">
                      {buttonLoader == false ? (
                        <Button onClick={formSubmit} className="mt-5">
                          Submit
                        </Button>
                      ) : (
                        <Button className="mt-5">Loading...</Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
}

export default Home;
